module.exports = __webpack_public_path__ + "img/px@2x.1ec72fa1.png";